import { render, staticRenderFns } from "./PostCreation_TagSuggestions.vue?vue&type=template&id=bfa85dac&scoped=true&"
import script from "./PostCreation_TagSuggestions.vue?vue&type=script&lang=js&"
export * from "./PostCreation_TagSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./PostCreation_TagSuggestions.vue?vue&type=style&index=0&id=bfa85dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa85dac",
  null
  
)

export default component.exports